export default __webpack_public_path__ + "static/media/saturn.f57bd923.png";